import Vue from 'vue'
import Video from './videoPlaye.vue'
let videoValue
function createToast() {
  const vnode = new Vue({
    render: h => h(Video)
  }).$mount()
  document.body.appendChild(vnode.$el)
  return vnode.$children[0]
}
function showVideo(args, callback) {
  // 为了让当前的实例 只有一个，防止占用太多内存
  if (!videoValue) {
    videoValue = createToast()
  }
  videoValue.showVideo(args)
  callback && callback()
}
const VideoPlay = {
  // install 是默认的方法。当外界在 use 这个组件的时候，就会调用本身的 install 方法，同时传一个 Vue 这个类的参数。
  install: function (Vue) {
    Vue.prototype.$showVideo = showVideo
  }
}

export default VideoPlay
